import axios from "./config"

//获取设备model_info列表
export function model_info_list (data) {
  return axios({
    url: '/deviceModelInfo/list',
    method: 'post',
    data
  })
}

//添加model_info
export function add_model_info (data) {
  return axios({
    url: '/deviceModelInfo/add',
    method: 'post',
    data
  })
}

//修改model_info
export function edit_model_info (data) {
  return axios({
    url: '/deviceModelInfo/update',
    method: 'post',
    data
  })
}

//删除model_info
export function del_model_info (params) {
  return axios({
    url: '/deviceModelInfo/delete',
    method: 'post',
    params
  })
}

//model-info版本列表
export function model_info_version_list (data) {
  return axios({
    url: '/deviceModelInfo/versionList',
    method: 'post',
    data
  })
}

//model_info详情
export function model_info_detail (params) {
  return axios({
    url: '/deviceModelInfo/info',
    method: 'post',
    params
  })
}

//model_info版本详情
export function model_info_version_detail (params) {
  return axios({
    url: '/deviceModelInfo/versionInfo',
    method: 'post',
    params
  })
}

//发布
export function publish (data) {
  return axios({
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    url: '/deviceModelInfo/publish',
    method: 'post',
    data
  })
}

//回滚
export function rollback (params) {
  return axios({
    url: '/deviceModelInfo/rollback',
    method: 'post',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/device_lib.js